import { authStore } from "@/store/auth";
import { cloudFunctions } from "@/store/cloudFunctions";

export async function addLearningLanguage({ lang, proficiency, reasonForLearning }) {
  // Fail closed if the endpoint isn't configured for this environment. A
  // non-absolute URL (e.g. an unfilled placeholder) resolves against the app
  // origin and the SPA/Capacitor catch-all answers 200 + index.html, which
  // reads as a successful add while nothing was written server-side.
  const endpoint = cloudFunctions.getManageLearningLanguageApi();
  if (!/^https?:\/\//i.test(endpoint)) {
    console.error("manageLearningLanguage endpoint is not configured:", endpoint);
    const error = new Error("endpointNotConfigured");
    error.code = "endpointNotConfigured";
    throw error;
  }
  const token = await authStore.getIdToken();
  const response = await fetch(endpoint, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify({ op: "add", lang, proficiency, reasonForLearning }),
  });
  const body = await response.json().catch(() => ({}));
  if (!response.ok) {
    const error = new Error(body.error || "addLanguageFailed");
    error.code = body.error || "unknown";
    throw error;
  }
  return body;
}
